import {api} from "./api";
import {MODERATOR_TEST} from "../mock/URLs";
import {GetTestByIdResponse} from "../types/test";

export const createTest = async (formData: FormData) => {
  try {
    const {data} = await api.post(MODERATOR_TEST, formData)
    return data;
  } catch (e) {
    throw e
  }
}


type GetTests = {
  params: {
    lesson: number
  }
}

export const getTests = async ({params}: GetTests) => {
  try {
    const {data} = await api.get(MODERATOR_TEST, {
      params
    })
    return data;
  } catch (e) {
    throw e;
  }
}

export const getTestById = async (id: number) => {
  try {
    const {data} = await api.get<{ data: GetTestByIdResponse }>(`${MODERATOR_TEST}${id}/`)
    return data.data;
  } catch (e) {
    throw e
  }
}

export const updateTest = async (id: number, formData: FormData) => {
  try {
    const {data} = await api.patch(`${MODERATOR_TEST}${id}/`, formData)
    return data;
  } catch (e) {
    throw e
  }
}